import React from 'react'
import '../Project.css';
import { Parallax } from 'react-parallax';
import Image1 from '../../Gemco-Website-Images/projects/Bvlgari_resorts_residenes_Dubai.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>Bvlgari Resorts</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>One of the world's most exclusive ultra-luxury resorts, set on a private seahorse-shaped island off Jumeirah Beach Road. The
                1.7 million sqft mixed-use development comprises 101 hotel rooms and suites, 20 villas, six residential buildings, 15 private
                mansions, and the world's first Bvlgari Yacht Club & Marina. Developer: Meraas.</p>
              <p>MAIN CONTRACTOR : ALEC</p>
              <p>MEP CONTRACTOR : ALEMCO</p>
              <p>GEMCO SCOPE OF WORKS : GEMCO SCOPE OF WORKS : Central plant room, hotel buildings, residential buildings
                and mansions — full CHW and associated MEP works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>

  )
}

export default Project_one